import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import { map, isEqual } from 'lodash';
import MarketsStore from 'stores/MarketsStore';
import MarketsAPIUtils from 'utils/MarketsAPIUtils';
import Input from 'components/ui/input';
import types from './TariffTypes';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

function getMarketsCodes(markets) {
  const codes = map(markets, market => market.code);
  return codes;
}

function validateName(name) {
  const length = (name) ? name.length : 0;
  if (length > 0) {
    return '';
  }
  return 'error';
}

class TariffPropsEditor extends React.Component {
  constructor(props) {
    super(props);
    const markets = getMarketsCodes(MarketsStore.getMarkets());
    this.state = {
      markets: markets || ['LAX', 'NYC', 'SFO', 'CHI'],
      isAllMarketsChecked: false,
    };
    this.onChange = ()=> this.handleMarketsStoreChange();
  }

  componentDidMount() {
    MarketsStore.addChangeListener(this.onChange);
    MarketsAPIUtils.getMarkets();
  }

  componentWillUnmount() {
    MarketsStore.removeChangeListener(this.onChange);
  }

  handleMarketsStoreChange() {
    const markets = getMarketsCodes(MarketsStore.getMarkets()).sort();
    const tariffMarkets = this.props.tariff.markets || [];
    tariffMarkets.sort();

    this.setState({
      markets,
      isAllMarketsChecked: isEqual(markets, tariffMarkets),
    });
  }

  handleNameChange() {
    return () => {
      const name = this.refs.nameInput.getValue();
      this.props.onChange('name', name);
    };
  }

  handleMarketsChange() {
    return () => {
      const node = ReactDOM.findDOMNode(this.refs.marketsList);
      const options = [].slice.call(node.querySelectorAll('option'));
      const selected = options.filter(function (option) {
        return option.selected;
      });
      const markets = selected.map(function (option) {
        return option.value;
      });
      this.props.onChange('markets', markets);
    };
  }

  handleTypeChange() {
    return () => {
      const type = this.refs.typeSelect.getValue();
      this.props.onChange('type', type);
    };
  }

  handleAllMarketsCheckbox() {
    return (e) => {
      const checked = e.target.checked;
      this.setState({ isAllMarketsChecked: checked });
      const markets = (checked) ? this.state.markets : [];
      this.props.onChange('markets', markets);
    };
  }

  handleDefaultTariffCheckbox() {
    return (e) => {
      const checked = e.target.checked;
      this.props.onChange('is_default', checked);
    };
  }

  render() {
    const {t} = this.props;
    const tariff = this.props.tariff || {};
    const markets = this.state.markets || [];
    const selectedMarkets = (this.state.isAllMarketsChecked) ? markets : tariff.markets;
    const flag = this.state.isAllMarketsChecked;
    let disableDefaultTariff = false;

    // If default tariff exists for current market, disable checkbox
    if (selectedMarkets && selectedMarkets.length) {
      let marketDefaultSet = this.props.tariffsList.filter((tar) => {
        if (tar.markets[0] === selectedMarkets[0] && tar.is_default && (tar._id !== tariff._id)) return tar;
        else return false
      });
      if (marketDefaultSet.length && !tariff.is_default || selectedMarkets.length > 1) disableDefaultTariff = true;
    }

    return (
      <Grid fluid>
        <Row className="show-grid">
          <Col xs={3}>
            <Input type="text" label={t('ID')} value={tariff._id} readOnly />
            <Input
              type="text"
              label={titleize(t('NAME'))}
              defaultValue={tariff.name}
              ref="nameInput"
              onChange={this.handleNameChange()}
              bsStyle={validateName(tariff.name)}
            />
            <Input
              type="select"
              label={t('TYPE')}
              placeholder="select"
              defaultValue={tariff.type}
              ref="typeSelect"
              onChange={this.handleTypeChange()}
              option={map(types, (type, index) => (
                <option value={type.value} key={`type-${index}`}>
                  {t(type.localizationSlug)}
                </option>
              ))}
            ></Input>
          </Col>
          <Col xs={5}>
            <Input
              disabled={this.state.isAllMarketsChecked}
              type="select"
              label={titleize(t('MARKET', {count:1}))}
              placeholder="select"
              value={selectedMarkets}
              onChange={this.handleMarketsChange()}
              ref="marketsList"
              multiple
              option={map(markets, (market, index) => (
                <option value={market} key={`market-${index}`}>
                  {market}
                </option>
              ))}
            ></Input>
            <Input
              type="checkbox"
              label={t('ALL_MARKETS')}
              checked={this.state.isAllMarketsChecked}
              ref="marketsCheckbox"
              onChange={this.handleAllMarketsCheckbox()}
            />
            <Input
              type="checkbox"
              label={
                disableDefaultTariff
                  ? t('DEFAULT_TARIFF_DISABLED')
                  : t('DEFAULT_TARIFF')
              }
              checked={tariff.is_default}
              ref="defaultTariffCheckbox"
              disabled={disableDefaultTariff}
              onChange={this.handleDefaultTariffCheckbox()}
            />
            {disableDefaultTariff && (
              <span style={{ fontSize: '11px' }}>
                {t('REMOVE_DEFAULT_TARIFF_MSG')}
              </span>
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

TariffPropsEditor.propTypes = {
  tariff: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withTranslation()(TariffPropsEditor);
